import styled from 'styled-components';

export const Container = styled.div`
  background-color: rgba(252, 252, 252, 1);
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  width: calc(550px - 80px);
  height: 100%;
  padding: 24px 40px 32px 40px;
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderText = styled.h2`
  font-size: 20px;
`;

export const HeaderClose = styled.div`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const SelectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
`;

export const SelectionText = styled.h2`
  font-size: 14px;
`;

export const SelectionList= styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 272px;
  overflow: scroll;
`;

export const SelectionItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const SelectedIcon = styled.div`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const SendContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const CommentSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 8px;
  padding-bottom: 8px;
  width: 100%;
  border-bottom: 1px solid rgba(218, 218, 218, 1);
`;

export const CommentPlaceholder = styled.input`
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  font-family: Inter-Regular;
  font-weight: 400;
  background-color: transparent;
  border: none;
  outline: none;
`;

export const SocialsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 24px;
  gap: 16px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
`;

export const SocialIcon = styled.img`
  cursor: pointer;
  width: 44px;
  height: 44px;
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  background-color: rgba(245, 245, 245, 1);
  border-radius: 8px;
  width: 100%;
  padding: 16px;
  white-space: nowrap;
`;

export const LinkText = styled.h2`
  font-size: 14px;
  overflow: hidden;
  max-width: 80%;
`;